// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_Zpu","cls2":"ResearchInterestSearchResults-cls2_bXP ResearchInterestSearchResults-cls1_Zpu"};